import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import DataType from "../types/dataType";
import Option from "../types/option";

interface DataState {
  dataTypes?: DataType[];
  xAxisTypes?: DataType[];
  yAxisTypes?: DataType[];
  xAxisIncrements?: Option[];
  status: "idle" | "loading" | "failed";
}

const initialState: DataState = {
  status: "idle",
};

export const getTypes = createAsyncThunk<DataType[]>(
  "data/get-types",
  async () => {
    const response = await http.get<DataType[]>("/data/types");
    return response.data;
  }
);

export const getXAxisTypes = createAsyncThunk<DataType[]>(
  "data/get-xAxis",
  async () => {
    const response = await http.get<DataType[]>("/data/xAxisTypes");
    return response.data;
  }
);

export const getYAxisTypes = createAsyncThunk<DataType[]>(
  "data/get-yAxis",
  async () => {
    const response = await http.get<DataType[]>("/data/yAxisTypes");
    return response.data;
  }
);

export const getXAxisIncrements = createAsyncThunk<Option[]>(
  "data/get-increments",
  async () => {
    const response = await http.get<Option[]>("/data/xAxisIncrements");
    return response.data;
  }
);

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    clearDataTypes(state) {
      state.dataTypes = initialState.dataTypes;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get data types
      .addCase(getTypes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getTypes.fulfilled, (state, action) => {
        state.status = "idle";
        state.dataTypes = action.payload;
      })
      .addCase(getTypes.rejected, (state, action) => {
        state.status = "failed";
      })
      // Get x-axis types
      .addCase(getXAxisTypes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getXAxisTypes.fulfilled, (state, action) => {
        state.status = "idle";
        state.xAxisTypes = action.payload;
      })
      .addCase(getXAxisTypes.rejected, (state, action) => {
        state.status = "failed";
      })
      // Get y-axis types
      .addCase(getYAxisTypes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getYAxisTypes.fulfilled, (state, action) => {
        state.status = "idle";
        state.yAxisTypes = action.payload;
      })
      .addCase(getYAxisTypes.rejected, (state, action) => {
        state.status = "failed";
      })
      // Get x-axis increments
      .addCase(getXAxisIncrements.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getXAxisIncrements.fulfilled, (state, action) => {
        state.status = "idle";
        state.xAxisIncrements = action.payload;
      })
      .addCase(getXAxisIncrements.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export const { clearDataTypes } = dataSlice.actions;

export default dataSlice.reducer;
